import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSword: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSword"><Path d="M13.6288 3L7.99609 10.0562L13.9444 16.0045L21.0006 10.3718V3H13.6288Z" fill="currentColor"/><Path d="M5.32021 9.10913L2.91034 12.3113L5.05376 15.8837L1.9375 18.9999L4.99816 22.0606L8.11442 18.9443L11.6868 21.0877L14.8889 18.6779L5.32021 9.10913Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSword;
